export default {
  data() {
    return {
      stateChanged: false,
    };
  },
  mounted() {
    this.stateChanged = false;
  },
  beforeRouteUpdate(to, from, next) {
    this.handleEditState(to, from, next);
  },
  beforeRouteLeave(to, from, next) {
    this.handleEditState(to, from, next);
  },
  methods: {
    modelUpdated() {
      this.stateChanged = true;
    },
    modelSaved() {
      this.stateChanged = false;
    },
    handleEditState(to, from, next) {
      if (this.stateChanged) {
        this.$bvModal.msgBoxConfirm(
          'There are unsaved changes on this page.  Are you sure you want to leave?', {
            cancelVariant: 'danger',
          },
        ).then((response) => {
          if (response) {
            next();
          } else {
            next(false);
          }
        }).catch(() => {
          next(false);
        });
      } else {
        next();
      }
    },
  },
};
